module.exports = __webpack_public_path__ + "static/media/default.ee1a7661.png";